function getLanguage() {
    const localizationToggleForm = document.getElementById("localization_form-toolbar");
    const languageSelectorDiv = localizationToggleForm?.getElementsByClassName("multi-selectors__item");
    const languageSelectorToggle = languageSelectorDiv?.[0]?.getElementsByClassName("disclosure__toggle");
    const languageSpan = languageSelectorToggle?.[0]?.getElementsByClassName("disclosure-list__label");
    const langugae = languageSpan?.[0]?.innerText.trim();
  
    const languageSelector = document.getElementById("locale_code");

    const languageArr = [
        { value: "Dutch", selectValue: "de", text: "Deutsch" },
        { value: "English", selectValue: "en", text: "English" },
        { value: "Spanish", selectValue: "es", text: "Español" },
        { value: "French", selectValue: "fr", text: "Français" },
        { value: "Italian", selectValue: "it", text: "Italiano" },
        { value: "German", selectValue: "nl", text: "Nederlands" },
        { value: "Portugais", selectValue: "pt-PT", text: "Português (Portugal)" },
    ]
    
    let languageSelected
    const footerLanguage = languageArr.find(lang => lang.selectValue.toLowerCase() === languageSelector?.value?.toLocaleLowerCase());

    if (footerLanguage)
        languageSelected = footerLanguage

    else
        languageSelected = languageArr.find(lang => lang.text.toLocaleLowerCase() === langugae?.toLocaleLowerCase())


    return languageSelected?.value
}

async function requestData({ urlForDatFetch, selectMessage, urlForNextPage, key, emptyMessage, queryKey }, nest) {

    const query = new URLSearchParams(window.location.search);

    if (!window.location.href.split("?")[1])
        urlForDatFetch = urlForDatFetch + "?lang=" + getLanguage();
    else if (window.location.search.includes("?"))
        urlForDatFetch = urlForDatFetch + "&lang=" + getLanguage();


    const res = await fetch(urlForDatFetch, {
        method: 'GET',
        headers: {
            'ngrok-skip-browser-warning': true
        },
    });

    if (res.status >= 500)
        document.getElementById("not-found").innerText = "Error code:500, Internal Error!"

    const data = await res.json();
    document.getElementById("page-heading").innerText = selectMessage;

    const categoriesListContaienr = document.getElementById('list-container');

    const loopData = !nest ? data : data[queryKey];
    if (loopData?.length > 0) {

        loopData.forEach(datum => {
            let url = urlForNextPage + datum.id

            const li = document.createElement("li");

            li.innerHTML = `<a href="${url}">${datum[key]}</a>`;

            categoriesListContaienr.appendChild(li)
        });

        return data
    }
    else {

        const maincontainer = document.querySelector(".list-main-container");
        maincontainer.remove();
        document.getElementById("not-found").style.display = "block"

        document.getElementById("not-found").innerText = emptyMessage
    }
}



async function fetchData() {

    const query = new URLSearchParams(window.location.search);

    const baseUrlForNextPage = "https://www.legendary-parts.com/pages/navigation-microfiches";
    const baseUrlForAPI = "https://admin-lp.com/api";
    const baseUrlForProductsPage = "https://www.legendary-parts.com/pages/microfiches-product";

    if (query.get("yearId")) {    //to get Categories Moto

        const queryData = {
            urlForDatFetch: baseUrlForAPI + "/categoriesmoto?yearId=" + query.get("yearId"),
            urlForNextPage: baseUrlForNextPage + "?categoriesMotoId=",
            selectMessage: "Categories",
            key: "categoriesMotoName",
            emptyMessage: "No Categories Moto found.",
            queryKey: "categoriesMotos"
        }
        const data = await requestData(queryData, true);

        if (data)
            BreadCrumbsCollection({ value: data?.yearRelations, key: "yearNumber" })

    }
    else if (query.get("categoriesMotoId")) { //to get models

        const queryData = {
            urlForDatFetch: baseUrlForAPI + "/models?categoriesMotoId=" + query.get("categoriesMotoId"),
            selectMessage: "Models",
            urlForNextPage: baseUrlForNextPage + "?modelId=",
            key: "modelName",
            emptyMessage: "No Model found.",
            queryKey: "models"
        }
        const data = await requestData(queryData, true)

        if (data) {
            const year = { value: data?.categoriesMotoRelations.year, key: "yearNumber" };
            const categoriesMoto = { value: data?.categoriesMotoRelations, key: "categoriesMotoName" };
            BreadCrumbsCollection(year, categoriesMoto)
        }
    }
    // else if (query.get("modelId")) {      //to get categories

    //     const queryData = {
    //         urlForDatFetch: baseUrlForAPI + "/categories?modelId=" + query.get("modelId"),
    //         selectMessage: "Categories",
    //         urlForNextPage: baseUrlForNextPage + "?categoryId=",
    //         key: "categoryName",
    //         emptyMessage: "No Category found.",
    //         queryKey: "categories"
    //     }
    //     const data = await requestData(queryData, true)
    //     if (data) {
    //         const model = { value: data?.modelRelations, key: "modelName" }
    //         const categoriesMoto = { value: data.modelRelations.categoriesMoto, key: "categoriesMotoName" };
    //         const year = { value: data.modelRelations.categoriesMoto.year, key: "yearNumber" };

    //         BreadCrumbsCollection(year, categoriesMoto, model)
    //     }
    // }
    else if (query.get("modelId")) {    //to get sub categories
        const queryData = {
            urlForDatFetch: baseUrlForAPI + "/subcategories?modelId=" + query.get("modelId"),
            selectMessage: "Sub-categories",
            urlForNextPage: baseUrlForProductsPage + "?subCategoryId=",
            key: "subCategoryName",
            emptyMessage: "No Sub Category found.",
            queryKey: "subCategories"
        }
        const data = await requestData(queryData, true);

        if (data) {

            const model = { value: data?.modelRelations, key: "modelName" };
            const categoriesMoto = { value: data.modelRelations.categoriesMoto, key: "categoriesMotoName" };
            const year = { value: data.modelRelations.categoriesMoto.year, key: "yearNumber" };

            BreadCrumbsCollection(year, categoriesMoto, model)
        }
    }


    else {// To get Years
        const queryData = {
            urlForDatFetch: baseUrlForAPI + "/years",
            selectMessage: "Years",
            urlForNextPage: baseUrlForNextPage + "?yearId=",
            key: "yearNumber",
            emptyMessage: "No Year found."
        }

        requestData(queryData)
    }
}

function BreadCrumb(breadCrumbData, arrow) {
    const { name, href } = breadCrumbData;

    const breadCrumbs_container = document.querySelector(".bread-crumb-container");

    const span = document.createElement("span")
    span.classList.add("bread-crumbs")

    const a = document.createElement("a");
    a.innerHTML = `${arrow ? '<i class="fa-solid fa-arrow-left-long"></i> ' : ""}  ${name}`;
    a.setAttribute("href", href)

    span.appendChild(a);

    breadCrumbs_container.appendChild(span)
}

function BreadCrumbsCollection(year, categoriesMoto, model, categories, subCategories, product) {
    const baseUrlForClientListsPage = "https://www.legendary-parts.com/pages/navigation-microfiches";
    const baseUrlForClientProductPage = "https://www.legendary-parts.com/pages/microfiches-product";

    if (year) {

        const href = `${baseUrlForClientListsPage}?${queryParamsSetter().toString()}`
        BreadCrumb({ href: href, name: year.value[year.key] }, true);
    }
    if (categoriesMoto) {

        const queries = [{ key: "yearId", value: year.value.id }];
        const href = `${baseUrlForClientListsPage}?${queryParamsSetter(queries,).toString()}`
        BreadCrumb({ href: href, name: categoriesMoto.value[categoriesMoto.key] }, true);
    }
    if (model) {

        const queries = [{ key: "categoriesMotoId", value: categoriesMoto.value.id }];
        const href = `${baseUrlForClientListsPage}?${queryParamsSetter(queries).toString()}`
        BreadCrumb({ href: href, name: model.value[model.key] }, true);
    }
    if (categories) {
        const queries = [{ key: "modelId", value: model.value.id }];
        const href = `${baseUrlForClientListsPage}?${queryParamsSetter(queries).toString()}`
        BreadCrumb({ href: href, name: categories.value[categories.key] }, true);
    }
    if (subCategories) {
        const queries = [{ key: "categoryId", value: categories.value.id }];
        const href = `${baseUrlForClientListsPage}?${queryParamsSetter(queries).toString()}`
        BreadCrumb({ href: href, name: subCategories.value[subCategories.key] }, true);
    }
    if (product) {
        const queries = [{ key: "subCategoryId", value: subCategories.value.id }];
        const href = `${baseUrlForClientProductPage}?${queryParamsSetter(queries).toString()}`;
        BreadCrumb({ href: href, name: product.value[product.key] }, true);
    }

}

function queryParamsSetter(queries) {
    const queryParams = new URLSearchParams();

    if (queries?.length)
        queries.forEach(query => queryParams.append(query.key, query.value));

    const urlQueryParams = new URLSearchParams(window.location.search);
    if (urlQueryParams.get("lang"))
        queryParams.append("lang", urlQueryParams.get("lang"))
    if (!window.location.href.split('?')[0]) {
        queryParams.append("lang", urlQueryParams.get("lang"))
    }
    return queryParams;
}


